<template>
    <header class="header_fix">
        <nav class="navbar">
            <a class="navbar-brand new_logo_well pb-0 pt-0" @click="homeRedircet" style="height:40px;">
                <img src="@/assets/images/logo.png" class="img-fluid" alt="">
                <template v-if="selfUserInfo">
                    <span class="administration_text" v-if="selfUserInfo.pro_payment">Neural Package (Pro)</span>
                    <span class="administration_text" v-else-if="selfUserInfo.auto_payment">Supervised Package
                        (Auto)</span>
                    <span class="administration_text" v-else>Natural Package (Regular)</span>
                </template>
            </a>
            <ul v-if="!isMobile" class="header_menu ml-auto mr-0">
                <li class="list-items">
                    <router-link class="menu_text_link" to="/home/" :class="showBtn ? '' : 'landing_btn' ">
                        <span class="menu_icon">
                            <i class="fa fa-home" aria-hidden="true" style="color:#7ac70c;font-size:38px;line-height:40px;"></i>
                        </span>
                        <span class="menu_text"> Home</span>
                    </router-link>
                </li>
                <template v-if="showBtn">
                    <li class="list-items">
                        <router-link class="menu_text_link" to="/webinar/"><span class="menu_icon">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="32" height="32" x="0"
                                    y="0" viewBox="0 0 445.44 445.44" style="enable-background:new 0 0 35 35"
                                    xml:space="preserve" class="">
                                    <g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                            <g>
                                                <path
                                                    d="M404.48,108.288H247.808l79.36-78.336l-14.336-14.336L230.4,96.512l-82.432-81.408L133.632,29.44l79.36,78.336H40.96    c-22.528,0-40.96,18.432-40.96,40.96v240.64c0,22.528,18.432,40.96,40.96,40.96h363.52c22.528,0,40.96-18.432,40.96-40.96v-240.64    C445.44,126.72,427.008,108.288,404.48,108.288z M276.48,336.64c0,16.896-13.824,30.72-30.72,30.72H87.04    c-16.896,0-30.72-13.824-30.72-30.72V203.52c0-16.896,13.824-30.72,30.72-30.72h158.72c16.896,0,30.72,13.824,30.72,30.72V336.64z     M353.28,355.072c-19.968,0-35.84-15.872-35.84-35.84c0-19.968,15.872-35.84,35.84-35.84s35.84,15.872,35.84,35.84    C389.12,339.2,373.248,355.072,353.28,355.072z M394.24,251.136h-81.92v-20.48h81.92V251.136z M394.24,199.936h-81.92v-20.48    h81.92V199.936z"
                                                    fill="#ff77ff" data-original="#000000" />
                                            </g>
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                        <g xmlns="http://www.w3.org/2000/svg">
                                        </g>
                                    </g>
                                </svg>
                            </span><span class="menu_text"> Webinar</span></router-link>
                    </li>
                    <li class="list-items">
                        <router-link class="menu_text_link" to="/members/">
                            <span class="menu_icon">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="42" height="42" x="0"
                                    y="0" viewBox="0 0 495.996 495"
                                    style="enable-background:new 0 0 512 512;margin-top:4px;" xml:space="preserve"
                                    class="">
                                    <g>
                                        <path xmlns="http://www.w3.org/2000/svg"
                                            d="m98.113281 188.535156c-49.769531 0-90.113281 40.390625-90.113281 90.214844v26.476562c0 7.140626 5.78125 12.925782 12.910156 12.925782h154.402344c7.132812 0 12.910156-5.785156 12.910156-12.925782v-26.476562c0-49.824219-40.34375-90.214844-90.109375-90.214844zm0 0"
                                            fill="#917fe5" data-original="#38b9d1" />
                                        <path xmlns="http://www.w3.org/2000/svg"
                                            d="m175.3125 326.152344h-154.402344c-11.53125 0-20.910156-9.386719-20.910156-20.925782v-26.476562c0-54.15625 44.011719-98.214844 98.113281-98.214844 54.09375 0 98.105469 44.058594 98.105469 98.214844v26.476562c.003906 11.539063-9.375 20.925782-20.90625 20.925782zm-77.199219-129.617188c-45.277343 0-82.113281 36.878906-82.113281 82.214844v26.476562c0 2.714844 2.203125 4.925782 4.910156 4.925782h154.40625c2.707032 0 4.910156-2.210938 4.910156-4.925782v-26.476562c-.003906-45.335938-36.839843-82.214844-82.113281-82.214844zm0 0"
                                            fill="#917fe5" data-original="#000000" />
                                        <path xmlns="http://www.w3.org/2000/svg"
                                            d="m147.648438 112.839844c0-27.394532-22.179688-49.597656-49.535157-49.597656-27.359375 0-49.539062 22.203124-49.539062 49.597656 0 27.390625 22.179687 49.59375 49.539062 49.59375 27.355469 0 49.535157-22.203125 49.535157-49.59375zm0 0"
                                            fill="#917fe5" data-original="#ffffff" />
                                        <path xmlns="http://www.w3.org/2000/svg"
                                            d="m98.113281 170.433594c-31.730469 0-57.542969-25.835938-57.542969-57.59375 0-31.761719 25.8125-57.59375 57.542969-57.59375 31.726563 0 57.535157 25.835937 57.535157 57.59375 0 31.753906-25.808594 57.59375-57.535157 57.59375zm0-99.1875c-22.910156 0-41.542969 18.660156-41.542969 41.59375 0 22.929687 18.632813 41.59375 41.542969 41.59375 22.902344 0 41.535157-18.660156 41.535157-41.59375 0-22.9375-18.632813-41.59375-41.535157-41.59375zm0 0"
                                            fill="#917fe5" data-original="#000000" />
                                        <path xmlns="http://www.w3.org/2000/svg"
                                            d="m447.425781 112.839844c0-27.394532-22.179687-49.597656-49.539062-49.597656-27.355469 0-49.535157 22.203124-49.535157 49.597656 0 27.390625 22.179688 49.59375 49.535157 49.59375 27.359375 0 49.539062-22.203125 49.539062-49.59375zm0 0"
                                            fill="#917fe5" data-original="#ffffff" />
                                        <path xmlns="http://www.w3.org/2000/svg"
                                            d="m397.886719 170.433594c-31.726563 0-57.535157-25.835938-57.535157-57.59375 0-31.761719 25.808594-57.59375 57.535157-57.59375 31.730469 0 57.542969 25.835937 57.542969 57.59375 0 31.753906-25.816407 57.59375-57.542969 57.59375zm0-99.1875c-22.902344 0-41.535157 18.660156-41.535157 41.59375 0 22.929687 18.632813 41.59375 41.535157 41.59375 22.910156 0 41.542969-18.660156 41.542969-41.59375 0-22.9375-18.636719-41.59375-41.542969-41.59375zm0 0"
                                            fill="#917fe5" data-original="#000000" />
                                        <path xmlns="http://www.w3.org/2000/svg"
                                            d="m397.886719 182.40625c-49.765625 0-90.109375 40.390625-90.109375 90.214844v26.476562c0 7.140625 5.777344 12.929688 12.910156 12.929688h154.402344c7.128906 0 12.910156-5.789063 12.910156-12.929688v-26.476562c0-49.824219-40.34375-90.214844-90.113281-90.214844zm0 0"
                                            fill="#917fe5" data-original="#38b9d1" style="" />
                                        <path xmlns="http://www.w3.org/2000/svg"
                                            d="m475.089844 320.03125h-154.402344c-11.53125 0-20.910156-9.390625-20.910156-20.925781v-26.480469c0-54.15625 44.011718-98.214844 98.105468-98.214844 54.101563 0 98.113282 44.058594 98.113282 98.214844v26.480469c.003906 11.535156-9.375 20.925781-20.90625 20.925781zm-77.203125-129.621094c-45.269531 0-82.105469 36.882813-82.105469 82.214844v26.480469c0 2.714843 2.203125 4.925781 4.910156 4.925781h154.40625c2.707032 0 4.910156-2.210938 4.910156-4.925781v-26.480469c-.007812-45.335938-36.84375-82.214844-82.121093-82.214844zm0 0"
                                            fill="#917fe5" data-original="#000000" />
                                        <path xmlns="http://www.w3.org/2000/svg"
                                            d="m248 162.191406c-69.996094 0-126.738281 56.804688-126.738281 126.886719v37.238281c0 10.042969 8.128906 18.179688 18.160156 18.179688h217.152344c10.03125 0 18.160156-8.136719 18.160156-18.179688v-37.238281c.003906-70.082031-56.738281-126.886719-126.734375-126.886719zm0 0"
                                            fill="#917fe5" data-original="#917fe5" />
                                        <path xmlns="http://www.w3.org/2000/svg"
                                            d="m356.578125 352.496094h-217.15625c-14.425781 0-26.160156-11.742188-26.160156-26.179688v-37.238281c0-74.375 60.4375-134.886719 134.738281-134.886719s134.738281 60.507813 134.738281 134.886719v37.238281c0 14.4375-11.734375 26.179688-26.160156 26.179688zm-108.578125-182.304688c-65.472656 0-118.738281 53.332032-118.738281 118.886719v37.238281c0 5.613282 4.558593 10.179688 10.160156 10.179688h217.152344c5.601562 0 10.160156-4.566406 10.160156-10.179688v-37.238281c.003906-65.554687-53.261719-118.886719-118.734375-118.886719zm0 0"
                                            fill="#917fe5" data-original="#000000" />
                                        <path xmlns="http://www.w3.org/2000/svg"
                                            d="m311.160156 74.519531c0-36.464843-29.523437-66.023437-65.941406-66.023437s-65.9375 29.558594-65.9375 66.023437c0 36.460938 29.519531 66.019531 65.9375 66.019531s65.941406-29.558593 65.941406-66.019531zm0 0"
                                            fill="#917fe5" data-original="#ffffff" />
                                        <path xmlns="http://www.w3.org/2000/svg"
                                            d="m245.21875 148.535156c-40.765625 0-73.9375-33.207031-73.9375-74.015625-.003906-40.816406 33.167969-74.023437 73.9375-74.023437 40.773438 0 73.941406 33.207031 73.941406 74.023437 0 40.808594-33.171875 74.015625-73.941406 74.015625zm0-132.039062c-31.945312 0-57.9375 26.03125-57.9375 58.023437 0 31.992188 25.992188 58.015625 57.9375 58.015625 31.949219 0 57.941406-26.027344 57.941406-58.015625 0-31.992187-25.992187-58.023437-57.941406-58.023437zm0 0"
                                            fill="#917fe5" data-original="#000000" />
                                    </g>
                                </svg>
                            </span>
                            <span class="menu_text">Members</span>
                        </router-link>
                    </li>
                    <li class="list-items">
                        <router-link class="menu_text_link" :to="{ name: 'vistaConference' }">
                            <span class="menu_icon">
                                <i class="fa fa-eye" aria-hidden="true" style="color:#fcf0c2;font-size:38px;"></i>
                            </span>
                            <span class="menu_text">Vista</span>
                        </router-link>
                    </li>
                    <li class="list-items">
                        <router-link class="menu_text_link" :to="{ name: 'paymentHistory' }">
                            <span class="menu_icon">
                                <i class="fa fa-usd" aria-hidden="true"
                                    style="color:#52f5df;font-size:30px;line-height: 40px;"></i>
                            </span>
                            <span class="menu_text">Payment</span>
                        </router-link>
                    </li>
                    <li class="list-items badge_wrp">
                        <i class="badge global_badge"
                            v-if="notificationBadgeInfo && notificationBadgeInfo.notificationUnreadCount > 0">{{
                                notificationBadgeInfo.notificationUnreadCount }}</i>
                        <router-link class="menu_text_link" :to="{ name: 'globalNotification' }">
                            <span class="menu_icon">
                                <i class="fa fa-bell" aria-hidden="true"
                                    style="color:#f7a500;font-size:30px;line-height: 40px;"></i>
                            </span>
                            <span class="menu_text">Notifications</span>
                        </router-link>
                    </li>
                    <li class="list-items logout_btn">
                        <a href="javascript:void(0)" @click="logoutMethod" class="menu_text_link">
                            <span class="menu_icon">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="31" height="31" x="0"
                                    y="0" viewBox="0 0 512.00533 512"
                                    style="enable-background:new 0 0 512 512;margin-top:2px;" xml:space="preserve"
                                    class="">
                                    <g>
                                        <path xmlns="http://www.w3.org/2000/svg"
                                            d="m320 277.335938c-11.796875 0-21.332031 9.558593-21.332031 21.332031v85.335937c0 11.753906-9.558594 21.332032-21.335938 21.332032h-64v-320c0-18.21875-11.605469-34.496094-29.054687-40.554688l-6.316406-2.113281h99.371093c11.777344 0 21.335938 9.578125 21.335938 21.335937v64c0 11.773438 9.535156 21.332032 21.332031 21.332032s21.332031-9.558594 21.332031-21.332032v-64c0-35.285156-28.714843-63.99999975-64-63.99999975h-229.332031c-.8125 0-1.492188.36328175-2.28125.46874975-1.027344-.085937-2.007812-.46874975-3.050781-.46874975-23.53125 0-42.667969 19.13281275-42.667969 42.66406275v384c0 18.21875 11.605469 34.496093 29.054688 40.554687l128.386718 42.796875c4.351563 1.34375 8.679688 1.984375 13.226563 1.984375 23.53125 0 42.664062-19.136718 42.664062-42.667968v-21.332032h64c35.285157 0 64-28.714844 64-64v-85.335937c0-11.773438-9.535156-21.332031-21.332031-21.332031zm0 0"
                                            fill="#fe4a3b" data-original="#000000" />
                                        <path xmlns="http://www.w3.org/2000/svg"
                                            d="m505.75 198.253906-85.335938-85.332031c-6.097656-6.101563-15.273437-7.9375-23.25-4.632813-7.957031 3.308594-13.164062 11.09375-13.164062 19.714844v64h-85.332031c-11.777344 0-21.335938 9.554688-21.335938 21.332032 0 11.777343 9.558594 21.332031 21.335938 21.332031h85.332031v64c0 8.621093 5.207031 16.40625 13.164062 19.714843 7.976563 3.304688 17.152344 1.46875 23.25-4.628906l85.335938-85.335937c8.339844-8.339844 8.339844-21.824219 0-30.164063zm0 0"
                                            fill="#fe4a3b" data-original="#000000" />
                                    </g>
                                </svg>
                            </span>
                            <span class="menu_text">Logout</span>
                        </a>
                    </li>
                </template>
            </ul>
            <mobileMenuBar v-if="isMobile" :notificationBadgeINFO="notificationBadgeInfo"></mobileMenuBar>
        </nav>
        <access-feature-of-blurb v-if="accessFeaturesOfPackageState"></access-feature-of-blurb>
    </header>
</template>
<script>
/*eslint-disable */

import accessFeaturesForBlurb from '@/components/public/access-features-of-package-popup';
import { bus } from '@/main';
import {mapGetters} from 'vuex';
import mobileMenuBar from '../mobile-menu-view/';
import responsiveMixin from '@/mixins/responsive';

const $ = window.jQuery = require('jquery');
export default {
    name: 'lymphomap-header',
    mixins: [responsiveMixin],
    components: {
        mobileMenuBar,
        'access-feature-of-blurb': accessFeaturesForBlurb
    },
    props: [],
    data() {
        return {
            showBtn: true,
            selfUserInfo: null,
            accessFeaturesOfPackageState: false,
            notificationBadgeInfo: null,
        }
    },
    computed: {
        ...mapGetters([
            'acUserDetailsStateGetters'
        ]),
        getUserDetailsAgainFun() {
            this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data;
            return;
        },
    },
    mounted() {
        // this.$store.dispatch('chatBroserNotificationFun').then((res)=>{
        //     if(window.location.pathname.indexOf('notifications') == -1) {
        //       this.notificationBadgeInfo = res.data.data;
        //     }
        // });
        bus.$on('selfUserUpdateStatus', (data) => {
            if(window.location.pathname.indexOf('notifications') == -1) {
                this.notificationBadgeInfo = data;
            }
        });
        bus.$on('showHeaderbtn', (data) => {
            this.showBtn = data;
        });
        bus.$on('accessFeaturesOfPackageStateBus', (data) => {
            this.accessFeaturesOfPackageState = data;
        });
        bus.$on('clearNotificationBadgeInfo', (data) => {
            this.notificationBadgeInfo = data;
        });
    },
    methods: {
        accessFeaturesOfPackagemethod() {
            this.accessFeaturesOfPackageState = true;
            document.body.classList.add('body_right_scroll_remove');
        },
        handleScroll() {
            let header = document.querySelector(".header_fix");
            let covid_19_popup = document.querySelector(".covid_19_popup");
            if (window.scrollY > 30 && !header.className.includes('darkBg')) {
                header.classList.add('darkBg');
                if (covid_19_popup) {
                    covid_19_popup.classList.add('moved_to_top_icon');
                }
            } else if (window.scrollY < 30) {
                header.classList.remove('darkBg');
                if (covid_19_popup) {
                    covid_19_popup.classList.remove('moved_to_top_icon');
                }
            }
        },
        logoutFromAllTabMethod() {
            if ('BroadcastChannel' in self) {
                authChannel.postMessage({
                    cmd: 'logout'
                })
            }
        },
        logoutMethod() {
            this.$store.dispatch('logoutAction')
                .then(() => {
                    this.logoutFromAllTabMethod();
                })
        },
        homeRedircet() {
            window.location.href = '/';
        }
    },
    watch: {
        getUserDetailsAgainFun() {
            return this.$store.getters.acUserDetailsStateGetters;
        },
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
}
</script>

<style lang="scss" scoped>
$color_1: #ffffff;
$color_2: #000000;
$color_3: #000;

header {
    background: rgba(0, 0, 0, 0.8);

    &.darkBg {
        background: #000 !important;
        box-shadow: 0px 0px 5px rgba(255, 247, 136, 0.1);
    }

    .navbar-brand {
        transform-origin: center center;
        -webkit-transform-origin: center center;
        position: relative;
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
        transition: transform ease 0.5s;
        -webkit-transition: transform ease 0.5s;
        -moz-transition: transform ease 0.5s;
        transform-origin: center center !important;
        cursor: pointer;

        &:hover {
            transform: scale(1.07);
            -webkit-transform: scale(1.07);
            -moz-transform: scale(1.07);
        }
    }

    .badge_wrp {
        position: relative;

        .badge {
            position: absolute;
            right: -5px;
            top: -5px;
            font-size: 10px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            font-style: normal;
            width: 18px;
            height: 18px;
            line-height: 17px;
            padding: 0;
            background: rebeccapurple;
            color: #fff;
            border-radius: 2px;
            z-index: 100;
            font-style: italic;
            border-radius: 20px;

            &.global_badge {
                background: #b41818;
                color: #fffcc4;
            }

            &.connectionRequest {
                left: -5px;
                background-color: #28a745;
                font-style: italic;
                border-radius: 20px;
            }
        }
    }

}



@media only screen and (max-width:1300px) {
    header .list-items a.menu_text_link {
        min-width: 90px;
        padding: 0px 2px;
    }

    .navbar-brand .img-fluid {
        max-width: 240px;
    }

    .header_menu li {
        margin-right: 12px;

        &:last-child {
            margin-right: 0px;
        }
    }
}

@media only screen and (max-width:1023px) {
    .new_logo_well {
        margin: 0px;
        height: auto !important;
    }
}

.administration_text {
    display: block;
    font-size: 12px;
    margin-top: 6px;
    color: #c4ffff;
    letter-spacing: .5px;
    line-height: 1;
}

.header_menu {
    margin: 0;
    display: flex;
    gap: 18px;
    align-items: center;

    .menu_text_link {
        padding: 0 10px;
        color: #ffd400;
        background-color: rgba(31, 31, 31, 0.5);
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        border: 1px solid rgba(174, 182, 184, 0.1);
        position: relative;
        overflow: hidden;
        display: inline-block;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        border-radius: 4px;
        font-weight: 700;
        letter-spacing: 0.5px;
        text-decoration: none;
        display: flex;
        white-space: nowrap;
        min-width: 85px;
        text-align: center;
        -webkit-transition: all .5s cubic-bezier(.42, 1.14, 1, 1);
        transition: all .5s cubic-bezier(.42, 1.14, 1, 1);
        .fa{
          color: #e6e4d1 !important;
          text-shadow: 0 0 3px #004fff, 0 0 5px #0043ff, 0 0 10px #0087ff;
        }
        svg *{fill:#e6e4d1 !important;}
        svg{filter: drop-shadow(0 0 1px #004fff) drop-shadow(0 0 2px #0043ff) drop-shadow(0 0 4px #0087ff);}
        &.landing_btn{
            min-width: 50px;
            height: 38px;
            line-height: 38px;
            border-radius: 4px;
         .fa{color:#ffd400 !important;font-size: 30px !important;text-shadow: none !important;line-height: 38px !important;}
        }
        .menu_icon {
            position: absolute;
            opacity: 1;
            left: 0;
            right: 0;
            margin: 0 auto;
            transition: all 1s cubic-bezier(.42, 1.14, 1, 1);
            -webkit-transition: all 1s cubic-bezier(.42, 1.14, 1, 1);
            -moz-transition: all 1s cubic-bezier(.42, 1.14, 1, 1);
            text-align: center;
        }

        .menu_text {
            display: block;
            opacity: 0;
            max-width: 0;
            transition: all .5s ease;
            -webkit-transition: all .5s ease;
            -moz-transition: all ease .5s;
            color: #ffffff;
            word-spacing: 3px;
            margin: 0 auto
        }

        &::before {
            content: "";
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(120deg,
                    transparent,
                    rgba(255, 255, 255, 0.2),
                    transparent);
            left: -100%;
            transition: all 0.65s ease-in-out;
        }

        &:hover {
            box-shadow: 1px 1px 25px 10px rgba(255, 255, 255, 0.5) !important;
            min-width: 150px !important;

            &::before {
                left: 100%;
            }

            .menu_icon {
                opacity: 0;
                transition: all .1s cubic-bezier(.42, 1.14, 1, 1);
                -webkit-transition: all .1s cubic-bezier(.42, 1.14, 1, 1);
                -moz-transition: all .1s cubic-bezier(.42, 1.14, 1, 1);
            }

            .menu_text {
                opacity: 1;
                max-width: 360px;
            }
        }

        &.router-link-active {
            background: #87cefa;
            .menu_icon {
                *{color: #000000 !important;}
                svg *{fill:#000000 !important;}
            }
            .menu_text{color:#000000 !important;}
            // min-width: 150px !important;

            // &::before {
            //     left: 100%;
            // }

            // .menu_icon {
            //     opacity: 0;
            //     transition: all .1s cubic-bezier(.42, 1.14, 1, 1);
            //     -webkit-transition: all .1s cubic-bezier(.42, 1.14, 1, 1);
            //     -moz-transition: all .1s cubic-bezier(.42, 1.14, 1, 1);
            // }

            // .menu_text {
            //     opacity: 1;
            //     max-width: 360px;
            // }
        }
    }
}
</style>